// =============================================================================
// sessionReelleContexte.js : les droits de la session RÉELLE, lus par le
// bandeau de commande (EnTetePage, bundle principal ; décision de Pierre du
// 27/10/2026). La roue dentée des réglages d'une page n'apparaît qu'à un
// administrateur de la session réelle, comme les gardes des pages et
// l'Administration du rail : « Voir comme » n'y change rien (App.jsx pose la
// valeur, isAdminApp). Hors de l'application (portail /espace-salarie, tests),
// aucune valeur n'est posée : personne n'est administrateur, aucune roue.
// =============================================================================
import { createContext, useContext } from "react";

const SANS_DROITS = Object.freeze({ estAdmin: false, estSuperAdmin: false });

export const SessionReelleContexte = createContext(SANS_DROITS);

// Valeurs STABLES (une par combinaison) : App.jsx les pose à chaque rendu sans
// réveiller les en-têtes de toutes les pages ouvertes.
const TABLE = Object.freeze({
  "00": SANS_DROITS,
  "10": Object.freeze({ estAdmin: true, estSuperAdmin: false }),
  "01": Object.freeze({ estAdmin: false, estSuperAdmin: true }),
  "11": Object.freeze({ estAdmin: true, estSuperAdmin: true }),
});
/** La valeur du contexte pour ces droits (même objet à chaque appel). */
export const droitsReels = (estAdmin, estSuperAdmin) => TABLE[`${estAdmin ? 1 : 0}${estSuperAdmin ? 1 : 0}`];

/** { estAdmin, estSuperAdmin } de la session réelle (faux hors application). */
export const useSessionReelle = () => useContext(SessionReelleContexte) || SANS_DROITS;
